import { CombinedGraphQLErrors } from '@apollo/client/errors';
import { useQuery } from '@apollo/client/react';
import type { GraphQLFormattedError } from 'graphql';
import { graphql } from '../../gql';
import type { DetailedBookingFragment } from '../../gql/graphql';

const detailedBookingQuery = graphql(/* GraphQL */ `
  query DetailedBookingQuery($bookingNo: Int!) {
    viewer {
      bookings {
        booking: byBookingNo(bookingNo: $bookingNo) {
          ...DetailedBooking
        }
      }
    }
  }
`);

export interface UseBookingLoaderResult {
  booking: DetailedBookingFragment | null | undefined;
  error: GraphQLFormattedError | undefined;
  loading: boolean;
}

export function useDetailedBooking(bookingNo: number): UseBookingLoaderResult {
  const { data, loading, error } = useQuery(detailedBookingQuery, {
    fetchPolicy: 'network-only',
    variables: { bookingNo },
  });

  const booking = data?.viewer?.bookings?.booking;

  return {
    loading,
    error: CombinedGraphQLErrors.is(error) ? error.errors[0] : undefined,
    booking,
  };
}
